import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-background text-foreground selection:bg-[#D4AF37] selection:text-black" data-id="element-424">
      <ScrollToTop data-id="element-425" />
      <Navbar data-id="element-426" />
      <main className="flex-grow" data-id="element-427">{children}</main>
      <Footer data-id="element-428" />
    </div>;
}